<template>
  <Header v-if="!routeNoHeader.includes($route.name)" />
  <div class="">
    <router-view />
  </div>
   <!-- <SideBar /> -->
  <span v-if="$route.name!='Dashboard'">
    <Footer />
  </span>
</template>
<script>
import Header from "./components/template/header.vue";
import Footer from "./components/template/footer.vue";
// import SideBar from "./components/template/SideBar.vue";
export default {
  name: "App",
   data() {
    return {
      routeNoHeader: [
        'printInvoice',
        'SystemLogin',
        'ForgetPassword',
        'SingUp'
      ],
    }
  },
  components: {
    // HelloWorld,
    Header,
    Footer,
    // SideBar
    //RegistrationForm
  }
};
</script>

<style></style>
